import { CellFn } from "@/graphHandling/graphTypes";
import { CellId } from "@/processes/CellId";

export const update_ulkomaatCheckbox: CellFn = (
  storeFunctions,
  intl,
  eventPayload
) => {
  if (!eventPayload) return false;

  storeFunctions.addModification(CellId.INITIALIZE_ULKOMAAT_CHECKBOX, {
    isChecked: eventPayload.changeProps.isChecked
  });

  return true;
};
